interface RunTotals {
  status: string;
  totalTargets: number;
  totalFindings: number;
}

/**
 * Findings per page for one run. Only a completed run that tested something has
 * one: 0/0 is not a density of zero, it is no measurement.
 */
export function runDensity({ status, totalTargets, totalFindings }: RunTotals): number | null {
  if (status !== 'completed' || totalTargets <= 0) return null;
  return totalFindings / totalTargets;
}
